import React from "react";

import { Box, Typography, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import makeStyles from "hooks/makeStyles";
import UtensilsIcon from "icons/UtensilsIcon";

const useStyles = makeStyles(theme => ({
	content: {
		padding: theme.spacing(2),
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		alignContent: "center",
		alignItems: "center"
	},
	title: {
		fontSize: 28,
		textTransform: "uppercase",
		textAlign: "center",
		lineHeight: "34px"
	},
	icon: {
		display: "flex",
		textAlign: "center",
		alignContent: "center",
		justifySelf: "center",
		fill: "#fff",
		[theme.breakpoints.up(480)]: {
			fill: theme.palette.text.primary
		}
	},
	message: {
		fontSize: 13,
		textTransform: "uppercase",
		textAlign: "center"
	}
}));

const OrderConfirmation = () => {
	const classes = useStyles();
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<Box className={classes.content}>
			<Typography className={classes.title}>{t("orderHasBeenPlaced")}</Typography>
			<Box className={classes.content}>
				<UtensilsIcon className={classes.icon} />
			</Box>
			<Typography className={classes.message}>{t("orderSubmitted")}</Typography>
		</Box>
	);
};

export default OrderConfirmation;
